window.InteractiveSwappableCardPanel = (randomId) => {
    return {
        container: null,
        cards: [],
        activeIndex: 0,

        init() {
            this.container = document.querySelector(
                `#InteractiveSwappableCardPanel-${randomId}`
            );

            this.identifyCards();
            this.attachEventListeners();
        },

        // Get fresh references + active index based on current DOM
        identifyCards() {
            this.cards = Array.from(
                this.container.querySelectorAll('.swappable-card')
            );

            const activeCard = this.container.querySelector(
                '.swappable-card.active'
            );

            if (activeCard) {
                this.activeIndex = this.cards.indexOf(activeCard);
            } else if (this.cards.length > 0) {
                // Fallback: make the first card active
                this.activeIndex = 0;
                this.cards[0].classList.add('active');
            }
        },

        attachEventListeners() {
            this.cards.forEach((card) => {
                // Remove previous handler if it exists
                if (card._clickHandler) {
                    card.removeEventListener('click', card._clickHandler);
                }

                card._clickHandler = () => {
                    const index = this.cards.indexOf(card);
                    if (index === this.activeIndex) return;

                    this.swapCards(index);
                };

                card.addEventListener('click', card._clickHandler);
            });
        },

        swapCards(newIndex) {
            if (newIndex === this.activeIndex) return;

            const activeCard = this.cards[this.activeIndex];
            const clickedCard = this.cards[newIndex];

            this.cards.forEach((card) => card.classList.remove('active'));
            clickedCard.classList.add('active');

            // Swap their positions in the DOM
            const activeParent = activeCard.parentNode;
            const clickedParent = clickedCard.parentNode;

            const clickedNext = clickedCard.nextSibling;

            // Placeholder to help swap across parents
            const placeholder = document.createElement('div');

            // Insert placeholder where the active card currently is
            activeParent.insertBefore(placeholder, activeCard);

            // Move active card to clicked card's position
            if (clickedNext) {
                clickedParent.insertBefore(activeCard, clickedNext);
            } else {
                clickedParent.appendChild(activeCard);
            }

            // Move clicked card to active card's original position
            activeParent.insertBefore(clickedCard, placeholder);

            // Remove placeholder
            placeholder.remove();

            // Re-sync the internal state with the new DOM structure
            this.identifyCards();
            this.attachEventListeners();
        },
      };
};
